import { HttpClient, HttpErrorResponse, HttpHeaders, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { lastValueFrom } from 'rxjs';
import { ICheckPlanLoadedResult } from "sharedFeatures/sharedServices/Responses/Auth/ICheckPlanLoadedResult";
import { IClearPlanTemplate } from "sharedFeatures/sharedServices/Responses/Auth/IClearPlanTemplate";
import { ICallKeepSessionAlive, IErrorResponse } from "sharedFeatures/sharedServices/Responses/redirect.index";
import { ILoadPlanResponse } from './Responses';

declare var appPath: string;

declare let handleAngularHttpError: any;

@Injectable()
export class RedirectService {
    constructor(private http: HttpClient) { }
    fullUrl: string = window.fullLiveUrl;
    //fullLandingUrl: string = '';
    accountUrl: string = "Account";

    public clearPlanTemplate() {
        // Wrap http response with the custom promise to handle error
        const response = this.http.post<string>(window.appPath + 'Auth/ClearPlanTemplate', {});
        return lastValueFrom(response)
            .then((res: string) => {
                return JSON.parse(res) as IClearPlanTemplate | IErrorResponse;
            })
            .catch((error: HttpErrorResponse) => {
                console.error('ClearPlanTemplate error', error);

                handleAngularHttpError(error);

                //if we need to transmit the error to a component
                throw error;
            });
    }

    openPlan(planguid: string) {
        let params = new HttpParams()
            .set('planGuid', planguid);

        // Wrap http response with the custom promise to handle error
        return new Promise<ILoadPlanResponse | IErrorResponse>((resolve, reject) => {
            const response = this.http.get<string>(window.appPath + 'BrixxFiles/LoadPlan', { params });
            lastValueFrom(response)
                .then((res: string) => {
                    let data: ILoadPlanResponse | IErrorResponse = { success: false, errorMessage: 'session timeout' };
                    if (res && res.length && res.indexOf("error=sessiontimeout") === -1) {
                        data = JSON.parse(res);
                    }
                    resolve(data);
                })
                .catch((error: HttpErrorResponse) => {
                    console.error('LoadPlan error', error);

                    handleAngularHttpError(error);

                    //if we need to transmit the error to a component
                    //reject(error);
                });
        });
    }

    openLandingSignIn() {
        if (typeof (appPath) == "undefined") return;
        window.location.href = appPath + 'sign-in';
    }

    openAccount() {
        if (typeof (appPath) == "undefined") return;
        window.location.href = appPath + 'Account';
    }

    openRefreshBilling(refNo: string) {
        if (typeof (appPath) == "undefined") return;
        window.location.href = appPath + 'Account?refreshBillingState=true&refNo=' + refNo;
    }

    CheckBalancerPlanLoaded(planGUID: string, userName: string) {
        const headers = new HttpHeaders({ 'Content-Type': 'application/json' });
        var data = { planGUID: planGUID, userName: userName };

        const response = this.http.post<string>(window.appPath + 'Auth/CheckBalancerPlanLoaded', data, { headers: headers });
        return lastValueFrom(response)
            .then((res: string) => {
                return JSON.parse(res) as ICheckPlanLoadedResult | IErrorResponse;
            })
            .catch(reason => {
                console.error('CheckBalancerPlanLoaded error', reason);
                handleAngularHttpError(reason);
            });
    }

    CallKeepSessionAlive(planGUID?: string): void {
        const headers = new HttpHeaders({ 'Content-Type': 'application/json' });
        var data = { planGUID };

        const response = this.http.post<string>(window.appPath + 'Auth/KeepSessionAlive', data, { headers: headers });
        lastValueFrom(response)
            .then((res: string) => {
                let data: ICallKeepSessionAlive = JSON.parse(res);

                if (window.buildVersion && window.buildVersion !== 'undefined' && window.buildVersion != data.buildVersion) {
                    window.dispatchEvent(new Event('needfrontrefresh-event'));
                }
            })
            .catch(reason => {
                console.error('KeepSessionAlive error', reason);
                handleAngularHttpError(reason);
            });
    }

    MarkSessionTimeout(isSessionTimeout: boolean): Promise<string> {
        let params = new HttpParams()
            .set('aSessionTimeout', isSessionTimeout.toString());

        // Wrap http response with the custom promise to handle error
        return new Promise((resolve, reject) => {
            const response = this.http.get<string>(window.appPath + 'Auth/MarkSessionTimeout', { params });
            lastValueFrom(response)
                .then((res: string) => {
                    resolve(res);
                })
                .catch((error: HttpErrorResponse) => {
                    console.error('MarkSessionTimeout error', error);

                    handleAngularHttpError(error);

                    //if we need to transmit the error to a component
                    //reject(error);
                });
        });
    }

    getAccountUrl() {
        return this.fullUrl + this.accountUrl;
    }

    toAccount() {
        document.location.assign(this.getAccountUrl());
    }

    toPeople() {
        localStorage.setItem('route','people')
        document.location.assign(this.getAccountUrl());
    }

    toCompany() {
        localStorage.setItem('route', 'company');
        document.location.assign(this.getAccountUrl());
    }

    toLicense() {
        localStorage.setItem('route', 'license');
        document.location.assign(this.getAccountUrl());
    }

    toProfile() {
        localStorage.setItem('route', 'myprofile');
        document.location.assign(this.getAccountUrl());
    }
}